/**
 * Minigame Timing Konfiguration (Shared zwischen Client und Server)
 *
 * Alle Zeitangaben in Millisekunden.
 * Diese Datei wird sowohl vom Client als auch vom Server importiert.
 */

const MINIGAME_TIMINGS = {
  splashDuration: 2000,           // Minispiel-Ankündigung
  countdownDuration: 2100,        // 3-2-1-Los Countdown
  tutorialDuration: 7000,         // Tutorial-Anzeige (bevor Timer startet)
  revealDuration: 5000,           // Reveal-Phase (richtige Antwort zeigen)
  rankingDisplayDuration: 5000,   // Ergebnis-Anzeige
  transitionDelay: 500,           // Übergang zwischen Phasen
  resumeDelay: 1000,              // Pause vor Spielfortsetzung
  safetyTimeout: 60000,           // Maximale Minispiel-Dauer (Legacy, nicht direkt verwendet)
  safetyBuffer: 30000,            // Puffer auf berechnete Safety-Dauer (ms)
  sequentialTurnDelay: 2000,      // Pause zwischen Sequential-Turns (Ergebnis anzeigen)
  resultAckTimeout: 10000,        // Timeout für Result-Bestätigung
  clientGracePeriod: 2000,        // Extra Zeit für Client-Reports nach Timer-Ende
};

// CommonJS export for server
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { MINIGAME_TIMINGS };
}

// ES6 export for client
export { MINIGAME_TIMINGS };
export default MINIGAME_TIMINGS;
